import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/app/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/app/src/i18n/LocaleContext.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.css");
